<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loadingModule" opacity="0.99">
        <div class="row">
          <div class="col-md-12">
            <v-btn class="v-primary" @click="$router.go(-1)">
              <span class="fa fa-arrow-left"></span> Voltar
            </v-btn>
          </div>
          <div class="col-md-4">
            <h3>
              <span class="text-muted">Módulo:</span>
              {{ module.description }}
            </h3>
            <h6>
              <span class="text-muted">Criação:</span>
              {{ formatDate(module.created_at) }}
            </h6>
            <h6>
              <span class="text-muted">Última alteração:</span>
              {{ formatDate(module.updated_at) }}
            </h6>
          </div>
          <div class="col-md-8">
            <form v-on:submit="update" method="post">
              <div class="row">
                <WarningRequiredFields />
                <ErrorsMessages :errors="errors" />
                <div class="col-md-12">
                  <LabelRequiredField label="Descrição" />
                  <input
                    :disabled="!permissions.modules.edit"
                    type="text"
                    v-model="description"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <LabelRequiredField label="Valor até 10 idosos" />
                  <input
                    :disabled="!permissions.modules.edit"
                    type="text"
                    v-model="value_up_to"
                    v-on:keyup="handleValueUpTo"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <LabelRequiredField label="Valor por idoso" />
                  <input
                    :disabled="!permissions.modules.edit"
                    type="text"
                    v-model="value_per"
                    v-on:keyup="handleValuePer"
                    class="form-control"
                  />
                </div>
                <div class="col-md-12 text-right">
                  <v-btn
                    v-if="permissions.modules.edit"
                    :disabled="loadingUpdate"
                    type="submit"
                    class="v-success"
                  >
                    <span class="fa fa-check"></span>
                    {{ loadingUpdate ? "Carregando" : "Salvar" }}
                  </v-btn>
                </div>
              </div>
            </form>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import routes from "../routes";
import api from "../services/api";
import toast from "../components/ToastNotification";

import {
  formatPrice,
  formatValueOnKeyUp,
  formatDate,
} from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "Module",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      module: {},
      id: "",
      description: "",
      value_up_to: "",
      value_per: "",
      loadingUpdate: false,
      loadingModule: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatPrice,
    formatValueOnKeyUp,
    formatDate,
    handleValueUpTo: function (e) {
      this.value_up_to = formatValueOnKeyUp(e.target.value);
    },
    handleValuePer: function (e) {
      this.value_per = formatValueOnKeyUp(e.target.value);
    },
    retrieve() {
      this.permissions = adminData().permissions;

      const { id } = routes.history.current.params;

      if (!id) {
        routes.push({ name: "modules" });
      }
      this.id = id;
      this.getModule(id);
    },
    async getModule(id) {
      try {
        this.loadingModule = true;

        const response = await api.get("/admin/module/get", { params: { id } });

        const { module } = response.data;

        this.module = module;
        this.description = module.description;
        this.value_up_to = formatPrice(module.value_up_to);
        this.value_per = formatPrice(module.value_per);
        this.loadingModule = false;
      } catch (error) {
        console.log(error);
      }
    },
    async update(event) {
      event.preventDefault();
      this.loadingUpdate = true;

      try {
        const { id, description, value_up_to, value_per } = this;
        let params = {
          id,
          description,
          value_up_to,
          value_per,
        };

        const response = await api.put("/admin/module/update", params);
        const { error, errors, message } = response.data;
        if (!error) {
          this.getModule(id);
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>